
<svg :width="width" :height="height" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.16663 8V13.3333C3.16663 13.687 3.3071 14.0261 3.55715 14.2761C3.8072 14.5262 4.14634 14.6667 4.49996 14.6667H12.5C12.8536 14.6667 13.1927 14.5262 13.4428 14.2761C13.6928 14.0261 13.8333 13.687 13.8333 13.3333V8"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.1667 6.00016L8.50004 3.3335L5.83337 6.00016"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M8.5 3.3335V10.6668" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
